import React, { useState } from "react";
import { trackEvent } from "@leafly-com/web-utils";
import cx from "classnames";
import compact from "lodash/compact";

import { useStrainPageContext } from "context/StrainPageContext";

import Image from "components/Image";
import LightBox from "components/LightBox";

import styles from "./StrainPage.module.css";

const HERO_MOBILE_SIZE = 295;
const HERO_DESKTOP_SIZE = 350;

export const HeroImage: React.FC = (): JSX.Element => {
  const { strain } = useStrainPageContext();

  const [showLightBox, setShowLightBox] = useState(false);

  const toggleLightBox = () => setShowLightBox(!showLightBox);

  const isStockImage = !!strain.stockNugImage;
  const secondaryImages =
    strain.highlightedPhotos?.map((p) => p.imageUrl) || [];
  const thumbnails = [strain.nugImage, ...secondaryImages];
  const lightboxPhotos = compact(thumbnails).map((photo, idx) => ({
    imageUrl: photo,
    ...(idx === 0 &&
      isStockImage && {
        imageTitle: `stock photo similar to ${strain.name || ""}`,
      }),
  }));

  return strain.nugImage && thumbnails.length ? (
    <div
      className={cx(
        styles.heroImageContainer,
        "relative flex items-center justify-center"
      )}
    >
      <div
        className={cx(
          styles.heroImage,
          "strain-page-hero-image mx-auto relative"
        )}
      >
        <button
          onClick={() => {
            toggleLightBox();
            trackEvent("Photos", "Click", "Strain photos");
          }}
          aria-label={`Click to view this photo of ${strain.name}`}
          data-testid="strain-light-box-image"
        >
          <Image
            alt={`Picture of ${strain.name}`}
            background
            backgroundFit="contain"
            disableLazyLoad
            preload
            sizes={[
              HERO_MOBILE_SIZE,
              null,
              null,
              HERO_DESKTOP_SIZE,
              null,
              HERO_MOBILE_SIZE,
            ]}
            src={strain.nugImage}
          />
        </button>
      </div>
      {isStockImage && (
        <div
          data-testid="hero-image-stock-photo"
          className="absolute -bottom-[22px] md:bottom-0 left-0 leading-[1rem] text-center w-full p-xs text-grey text-xs"
        >
          stock photo similar to {strain.name}
        </div>
      )}
      {showLightBox && (
        <LightBox
          images={lightboxPhotos}
          onToggleLightboxClick={toggleLightBox}
        />
      )}
    </div>
  ) : (
    <></>
  );
};

export default HeroImage;
